export var EngagementResultEnum;
(function (EngagementResultEnum) {
    EngagementResultEnum["Failure"] = "Failure";
    EngagementResultEnum["Success"] = "Success";
})(EngagementResultEnum || (EngagementResultEnum = {}));
//# sourceMappingURL=engagement-data.js.map